import { createAppAsyncThunk } from '../../store/extensions';
import {
  fetchEnhancedSurveySubmissionsCall,
  resetEnhancedSurveySubmissionCall,
} from './service';

export const fetchEnhancedSurveySubmissions = createAppAsyncThunk(
  'healthJourney/getEnhancedSurveySubmissions',
  fetchEnhancedSurveySubmissionsCall
);

export const resetEnhancedSurveySubmission = createAppAsyncThunk(
  'healthJourney/resetEnhancedSurveySubmission',
  (sessionId: string) => resetEnhancedSurveySubmissionCall(sessionId)
);
